
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 13.95 13.95\" id=\"plus\" ><title>Asset 2</title><g data-name=\"Layer 2\"><g data-name=\"Layer 1\"><path d=\"M7 14a.75.75 0 0 1-.75-.75V.75a.75.75 0 0 1 1.5 0V13.2A.75.75 0 0 1 7 14z\"/><path d=\"M13.2 7.73H.75a.75.75 0 0 1 0-1.5H13.2a.75.75 0 0 1 0 1.5z\"/></g></g></symbol>";
module.exports = sprite.add(image, "plus");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus.svg
// module id = 308
// module chunks = 1